export default __webpack_public_path__ + "media/OTT&Video.6acfee0c.svg";